module.exports = __webpack_public_path__ + "img/palette-1_fg_en.5938951.jpg";